/* eslint-disable react/no-unknown-property */
import React from 'react';
import * as styles from './AgentRankPosition.style';
import { RankType } from '../../../providers/api/dtos';
import useIsDevice from '../../../hooks/use-is-device/useIsDevice';
import { getConfigByRank } from '../../utils/getConfigByRank';

export interface AgentRankPositionProps {
  rank: number,
  rankingType?: RankType,
  size?: 'S' | 'M',
}

const AgentRankPosition: React.FC<AgentRankPositionProps> = ({
  rank,
  rankingType = 'AGENT',
  size = 'M',
}) => {
  const isMobile = useIsDevice('mobile');

  const config = React.useMemo(
    () => getConfigByRank(rank, rankingType),
    [rank, rankingType],
  );

  return (
    <div
      css={styles.rankBox}
      $color={config.color}
    >
      {((size === 'M' && !isMobile) || config.color !== 'neutral') && (
        <div css={styles.rankLabel}>
          {config.label}
        </div>
      )}
      <div
        css={styles.rankPosition}
        $color={config.color}
        $size={size}
        $isMobile={isMobile}
      >
        {config.color === 'neutral' ? '#' : ''}
        <strong>{config.shownPosition}</strong>
      </div>
    </div>
  );
};

export default AgentRankPosition;
